import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class BearerInterceptor implements HttpInterceptor {

  constructor(private msalService: OAuthService, private userService: UserService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let userToken = this.userService.idToken;
    if (userToken) {
      if (request.url.indexOf("googleapis") > 0) {
        userToken = this.userService.accessToken;
      }
      const modifiedReq = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${userToken}`),
      });
      return next.handle(modifiedReq);


    } else {
      return next.handle(request);
    }
  }
}